<template>
  <div id="app">
    <Nav v-if="!$route.meta.hideNav" />

    <main class="app-main">
      <keep-alive :include="cachedComponents">
        <router-view></router-view>
      </keep-alive>
    </main>

    <Service v-if="!$route.meta.hideService" />
    <Footer v-if="!$route.meta.hideFooter" />

    <!-- 全局图片预览弹窗 -->
    <el-dialog
      :visible.sync="previewVisible"
      width="90%"
      append-to-body
      center
      custom-class="global-image-previewer"
      :show-close="false"
    >
      <div class="preview-toolbar">
        <el-button-group>
          <el-button
            type="primary"
            icon="el-icon-zoom-in"
            circle
            @click="zoomIn"
            title="放大"
          ></el-button>
          <el-button
            type="primary"
            icon="el-icon-zoom-out"
            circle
            @click="zoomOut"
            title="缩小"
          ></el-button>
          <el-button
            type="primary"
            icon="el-icon-refresh-left"
            circle
            @click="rotateLeft"
            title="左旋转"
          ></el-button>
          <el-button
            type="primary"
            icon="el-icon-refresh-right"
            circle
            @click="rotateRight"
            title="右旋转"
          ></el-button>
          <el-button
            type="success"
            icon="el-icon-download"
            circle
            @click="downloadImg"
            title="下载图片"
          ></el-button>
          <el-button
            type="warning"
            icon="el-icon-printer"
            circle
            @click="printImg"
            title="打印图片"
          ></el-button>
          <el-button
            type="danger"
            icon="el-icon-close"
            circle
            @click="previewVisible = false"
            title="关闭"
          ></el-button>
        </el-button-group>
      </div>
      <div
        class="preview-content"
        ref="previewContent"
        @mousedown="startDrag"
        @mousemove="onDrag"
        @mouseup="endDrag"
        @mouseleave="endDrag"
        @wheel.prevent="handleWheel"
      >
        <img
          :src="previewUrl"
          :style="imageStyle"
          alt="预览图片"
          ref="previewImg"
          draggable="false"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Nav from "@/components/nav.vue";
import Footer from "@/components/footer.vue";
import Service from "@/components/service.vue";

export default {
  name: "App",
  components: {
    Nav,
    Footer,
    Service,
  },
  data() {
    return {
      previewVisible: false,
      previewUrl: "",
      scale: 1,
      rotate: 0,
      translateX: 0,
      translateY: 0,
      isDragging: false,
      startX: 0,
      startY: 0,
      // 需要缓存的组件名称列表
      cachedComponents: [
        "homeIndex",
        "Invitation",
        "NoticeList",
        "ProjectList",
        "ProjectServices",
        "AllNews",
        "GroupNews",
        "TradeNews",
        "MediaCoverage",
        "CaiList",
        "CaiTable",
        "CaModule",
        "news",
      ],
    };
  },
  computed: {
    imageStyle() {
      return {
        transform: `scale(${this.scale}) rotate(${this.rotate}deg) translate(${this.translateX}px, ${this.translateY}px)`,
        transition: this.isDragging ? "none" : "transform 0.3s ease",
        maxWidth: "none", // 允许放大超过容器
        maxHeight: "none",
        cursor: this.isDragging ? "grabbing" : "grab",
      };
    },
  },
  watch: {
    previewVisible(val) {
      if (val) {
        // 重置状态
        this.scale = 1;
        this.rotate = 0;
        this.translateX = 0;
        this.translateY = 0;
      }
    },
  },
  mounted() {
    // 全局监听图片点击事件，用于 v-html 中的图片预览
    window.addEventListener("click", this.handleGlobalClick);
  },
  beforeDestroy() {
    window.removeEventListener("click", this.handleGlobalClick);
  },
  methods: {
    handleGlobalClick(e) {
      const target = e.target;
      // 检查是否点击了图片，并且该图片是否在富文本容器内
      if (target.tagName === "IMG") {
        const richTextContainers = [
          ".rich-text-content",
          ".detail-body",
          ".content-body",
          ".contain",
          ".question_text",
          ".result-desc",
          ".result-content",
          ".intro-text",
          ".answer",
        ];

        const isInsideRichText = richTextContainers.some((selector) =>
          target.closest(selector),
        );

        if (isInsideRichText) {
          this.previewUrl = target.src;
          this.previewVisible = true;
        }
      }
    },
    zoomIn() {
      this.scale = Math.min(this.scale + 0.2, 5);
    },
    zoomOut() {
      this.scale = Math.max(this.scale - 0.2, 0.2);
    },
    rotateLeft() {
      this.rotate -= 90;
    },
    rotateRight() {
      this.rotate += 90;
    },
    handleWheel(e) {
      if (e.deltaY < 0) {
        this.zoomIn();
      } else {
        this.zoomOut();
      }
    },
    startDrag(e) {
      if (this.scale <= 1 && this.rotate === 0) return;
      this.isDragging = true;
      this.startX = e.clientX - this.translateX;
      this.startY = e.clientY - this.translateY;
    },
    onDrag(e) {
      if (!this.isDragging) return;
      this.translateX = e.clientX - this.startX;
      this.translateY = e.clientY - this.startY;
    },
    endDrag() {
      this.isDragging = false;
    },
    downloadImg() {
      const link = document.createElement("a");
      link.href = this.previewUrl;
      link.download = `image_${new Date().getTime()}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    printImg() {
      const printWindow = window.open("", "_blank");
      printWindow.document.write(
        `<html><body style="margin:0;display:flex;justify-content:center;align-items:center;"><img src="${this.previewUrl}" style="max-width:100%;height:auto;"></body></html>`,
      );
      printWindow.document.close();
      printWindow.onload = () => {
        printWindow.print();
        printWindow.close();
      };
    },
  },
};
</script>

<style lang="less">
@import "./assets/styles/global.less";

#app {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.app-main {
  flex: 1;
  width: 100%;
}

/* 全局图片预览弹窗样式优化 */
.global-image-previewer {
  background: rgba(0, 0, 0, 0.8) !important;
  box-shadow: none !important;
  margin-top: 5vh !important;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
    height: 90vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .preview-toolbar {
    padding: 20px;
    display: flex;
    justify-content: center;
    z-index: 10;
    background: rgba(0, 0, 0, 0.5);

    .el-button {
      font-size: 20px;
      margin: 0 10px;
      background: rgba(255, 255, 255, 0.1);
      border: 1px solid rgba(255, 255, 255, 0.3);
      color: #fff;

      &:hover {
        background: rgba(255, 255, 255, 0.2);
      }
    }
  }

  .preview-content {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    position: relative;
    user-select: none;

    img {
      max-width: 80%;
      max-height: 80%;
      object-fit: contain;
      box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
    }
  }
}
</style>
